(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
if (!customElements.get("c-mobile-menu")) {
  customElements.define(
    "c-mobile-menu",
    class ComponentMobileMenu extends HTMLElement {
      constructor() {
        super();

      }

      connectedCallback() {
        this.header = document.querySelector("s-header");
        this.body = document.querySelector("body");
        window.PubSub.subscribe("mobile-menu", this.mobileMenuHandler);
        window.addEventListener("resize", this.calculateHeight)
      }

      disconnectedCallback() {
        window.removeEventListener("resize", this.calculateHeight)
      }

      mobileMenuHandler = (active) => {
        this.calculateHeight();

        if(active) {
          this.body.classList.remove("modal-open")
          this.classList.remove("is-active")
        } else {
          this.body.classList.add("modal-open")
          this.classList.add("is-active")
        }
      }

      calculateHeight = () => {
        if(!this.header) return;

        let rect = this.header.getBoundingClientRect();

        this.style.top = rect.top + rect.height + "px";
        this.style.height = `calc(100dvh - ${rect.top + rect.height}px)`
      }
    }
  );
}

},{}]},{},[1])

